angular.module('cloudX').directive('editableCurrency', [
  'editableDirectiveFactory',
  '$timeout',
  function(editableDirectiveFactory, $timeout) {
    var dir = editableDirectiveFactory({
      directiveName: 'editableCurrency',
      inputTpl: '<cx-currency-typeahead ng-change="submitOnChange()"></cx-currency-typeahead>',
      render: function() {
        this.parent.render.call(this);
      },
      autosubmit: function() {
        var self = this;
        self.scope.submitOnChange = function() {
          $timeout(function() {
            self.scope.$form.$submit();
          }, 100);
        };
        self.editorEl.on('keyup', function(e) {
          if (!self.single) {
            return;
          }
          switch (e.keyCode) {
            // hide on `escape` press
            case 27:
              self.scope.$apply(function() {
                self.scope.$form.$cancel();
              });
              break;
          }
        });
      },
    });
    return dir;
  },
]);
